var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"stat",rawName:"v-stat.click",value:({
    tag: 'mainpage.switchbtn_click|wecoupons-首页-切换目录',
    ext: {
      fstate: _vm.biType,
    },
  }),expression:"{\n    tag: 'mainpage.switchbtn_click|wecoupons-首页-切换目录',\n    ext: {\n      fstate: biType,\n    },\n  }",modifiers:{"click":true}}],staticClass:"switch-btn",attrs:{"aria-label":_vm.ariaSwitchText,"role":"text"},on:{"click":_vm.handleClick}},[(_vm.type === _vm.ViewType.merchantList)?_c('div',{staticClass:"switch-btn-coupon"}):_c('div',{staticClass:"switch-btn-mch"},[(_vm.isShowMchTip)?_c('div',{staticClass:"switch-btn-mch-tip"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }